import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';

export default [
    {
        name: 'insights',
        path: '/dashboards/insights',
        component: () => import('@/pages/edverum-insights/EdverumInsights.vue'),
        props: false,
        children: [
            {
                name: 'insights-bell-curve',
                path: 'bell-curve',
                component: () => import('@/pages/bell-curve/BellCurveParent.vue'),
            },
        ],
        beforeEnter: FeatureMiddleware('INSIGHTS'),
        ability: ({ gateKeeper }) =>
            gateKeeper.userHasPermission('view insight dashboard') ||
            gateKeeper.userHasGroupPermission('view insight dashboard') ||
            gateKeeper.userIsGroupInstructor(),
    },
];
